import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Loading } from '~/components/Loading';

export const Route = createFileRoute('/_auth/home/')({
  component: RouteComponent,
  pendingComponent: () => <Loading />,
});

function RouteComponent() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: '/' });
  }, [navigate]);

  return null;
}
